<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{housekeepingServPoolPayOrderInfo.servName}}待支付</span>
            <div>
              <el-button type="primary" size="small" @click="_back">返回</el-button>
            </div>
          </div>
          <el-table
            :data="housekeepingServPoolPayOrderInfo.fees"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column prop="typeName" label="费用大类" align="center"></el-table-column>
            <el-table-column prop="feeName" label="费用名称" align="center"></el-table-column>
            <el-table-column prop="price" label="收费金额" align="center"></el-table-column>
            <el-table-column prop="payPrice" label="实收金额" align="center"></el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                {{scope.row.state == '1001'?'未支付':'已支付'}}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="18"></el-col>
      <el-col :span="4">
        <div style="text-align: right; line-height: 60px;">
          缴费金额：<span style="font-size: 30px; color: red;">{{housekeepingServPoolPayOrderInfo.feePrices}}元</span>
        </div>
      </el-col>
      <el-col :span="2">
        <el-button 
          type="warning" 
          size="large" 
          style="width: 100%; margin-bottom: 10px;"
          @click="_payFee"
        >
          缴费
        </el-button>
      </el-col>
    </el-row>

    <el-dialog
      title="缴费二维码"
      :visible.sync="qrDialogVisible"
      width="30%"
      center
    >
      <div class="text-center">
        <div id="qrcode" style="width:200px; height:200px; margin: 0 auto;"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="_back">支付完成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryStoreOrderCartFee, toQrServFeePay } from '@/api/housekeeping/housekeepingServPoolPayOrderApi'

export default {
  name: 'HousekeepingServPoolPayOrder',
  data() {
    return {
      qrDialogVisible: false,
      housekeepingServPoolPayOrderInfo: {
        fees: [],
        poolId: '',
        servName: '',
        feePrices: 0.0,
        codeUrl: ''
      }
    }
  },
  created() {
    this.housekeepingServPoolPayOrderInfo.poolId = this.$route.query.poolId
    this.housekeepingServPoolPayOrderInfo.servName = this.$route.query.servName
    this._loadPoolFees()
  },
  methods: {
    async _loadPoolFees() {
      try {
        const params = {
          page: 1,
          row: 50,
          state: '1001',
          poolId: this.housekeepingServPoolPayOrderInfo.poolId,
          shopId: getShopId()
        }
        const res = await queryStoreOrderCartFee(params)
        let feePrices = 0.0
        res.data.forEach(item => {
          feePrices += parseFloat(item.payPrice)
        })
        this.housekeepingServPoolPayOrderInfo.feePrices = feePrices
        this.housekeepingServPoolPayOrderInfo.fees = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _payFee() {
      try {
        const data = {
          shopId: getShopId(),
          poolId: this.housekeepingServPoolPayOrderInfo.poolId,
        }
        const res = await toQrServFeePay(data)
        if (res.code === 0) {
          this.housekeepingServPoolPayOrderInfo.codeUrl = res.codeUrl
          this._viewQr(res.codeUrl)
          this.qrDialogVisible = true
          this.$message.success(res.msg)
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('支付请求失败')
      }
    },
    _back() {
      this.qrDialogVisible = false
      this.$router.go(-1)
    },
    _viewQr(url) {
      document.getElementById("qrcode").innerHTML = ""
      let qrcode = new Window.QRCode(document.getElementById("qrcode"), {
        text: "服务费用",
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: window.QRCode.CorrectLevel.H
      })
      qrcode.makeCode(url)
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>